<template>
    <div>
      <!-- 增加按钮 -->
      <el-button
        type="primary"
        style="margin-top: 10px;"
        @click="openAddDialog()"
       
      >
        <i class="el-icon-plus"></i> 增加
      </el-button>
  
      <!-- 表格 -->
      <el-table
        :data="noticeData"
        style="width: 100%"
        stripe
      >
        <el-table-column
          label="作者"
          prop="author"
          width="180"
        ></el-table-column>
        <el-table-column
          label="标题"
          prop="title"
          width="180"
        ></el-table-column>
        <el-table-column
          label="时间"
          prop="createTime"
        ></el-table-column>
        <el-table-column
          text-align="right"
        >
        <template slot="header">
            <el-row :gutter="10" text-align="middle">
                <el-col :span="18">
                <input
                    placeholder="请输入作者"
                    v-model="searchWord"
                    style="border: 1px solid #DCDFE6;
                        border-radius: 5px;
                        height: 30px;
                        width: 100%;"
                />
                </el-col>
                <el-col :span="6">
                    <el-button type="primary" icon="el-icon-search" style="width: 100%; height: 35px;" @click="searchByTitle()">搜索</el-button>
                </el-col>
            </el-row>
        </template>
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="openEditDialog(scope.$index, scope.row)"
            >编辑</el-button>
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row)"
            >删除</el-button>
            <el-button type="primary" size="mini" @click="goNoticePage(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
  
      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px; text-align: right;"
        background
        layout="prev, pager, next"
        :total="totalElements"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change="handlePageChange"
      ></el-pagination>
      <!-- 增加弹窗 -->
      <el-dialog
        title="新增通知"
        :visible.sync="addDialogVisible"
        width="30%"
      >
        <el-form :model="addForm" label-width="80px">
          <el-form-item label="作者">
            <el-input v-model="addForm.author"></el-input>
          </el-form-item>
          <el-form-item label="内容">
            <el-input v-model="addForm.content"></el-input>
          </el-form-item>
          <el-form-item label="标题">
            <el-input v-model="addForm.title"></el-input>
          </el-form-item>
          <el-form-item label="时间">
            <el-date-picker
              v-model="addForm.createTime"
              type="datetime"
              placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleAdd">确定</el-button>
        </span>
      </el-dialog>
  
      <!-- 编辑弹窗 -->
      <el-dialog
        title="编辑通知"
        :visible.sync="editDialogVisible"
        width="30%"
      >
        <el-form :model="editForm" label-width="80px">
          <el-form-item label="作者">
            <el-input v-model="editForm.author"></el-input>
          </el-form-item>
          <el-form-item label="内容">
            <el-input v-model="editForm.content"></el-input>
          </el-form-item>
          <el-form-item label="标题">
            <el-input v-model="editForm.title"></el-input>
          </el-form-item>
          <el-form-item label="时间">
            <el-date-picker
              v-model="editForm.createTime"
              type="datetime"
              placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleEdit">确定</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    name: 'NoticeTable',
    data() {
      return {
        noticeData: [], // 表格数据
        totalElements:0,
        search: '', // 搜索关键字
        searchWord:'',
        currentPage: 1, // 当前页码
        pageSize: 10, // 每页显示条数
        addDialogVisible: false, // 增加弹窗是否显示
        editDialogVisible: false, // 编辑弹窗是否显示
        addForm: { // 增加表单数据
          author: '',
          title: '',
          createTime: '',
          content:''
        },
        editForm: { // 编辑表单数据
          author: '',//作者
          title: '',//标题
          createTime: '',//创建时间
          content:''//内容
        },
        editIndex: -1, // 当前编辑的行索引
      };
    },
    computed: {
      // 过滤后的数据（根据搜索关键字）
      filteredData() {
        return this.noticeData.filter(
          (data) =>
            !this.search ||
            data.title.toLowerCase().includes(this.search.toLowerCase())
        );
      },
      handleSizeChange(){},
      handleCurrentChange(){},
      
      // 分页后的数据
      paginatedData() {
        const start = (this.currentPage - 1) * this.pageSize;
        const end = start + this.pageSize;
        return this.filteredData.slice(start, end);
      },
    },
    created() {
      this.queryNotice(); // 初始化时加载数据
    },
    methods: {
      // 打开增加弹窗
      openAddDialog() {
        const currentAuthor = this.getCookie('username')
        this.addForm = { author: currentAuthor, title: '', createTime: '' }; // 清空表单
        this.addDialogVisible = true;
      },
      // 打开编辑弹窗
      openEditDialog(index, row) {
        this.editForm = { ...row }; // 填充表单数据
        this.editIndex = index; // 记录编辑的行索引
        this.editDialogVisible = true;
      },
      // 增加操作
      handleAdd() {
        axios.post('http://www.wjyzlj.cn/pet/notice',this.addForm)
        .then(response => {
            console.log(response.data)
            if(response.data.code == 200){
                this.$message({
                    message:'添加成功',
                    type:'success'
                })
                if(response.data.code != 200){
                    this.$message.error("添加失败")
                }
                 window.location.reload()//刷新页面
            }
        })
        .catch(error => {
            console.log(error)
        })
        this.addDialogVisible = false; // 关闭弹窗
      },
      // 编辑操作
      handleEdit() {
        // 更新数据
        axios.put('http://www.wjyzlj.cn/pet/notice',this.editForm)
        .then(response => {
            console.log(response.code)
        })
        .catch(error => {
            console.log(error)
        })
        window.location.reload()
        this.editDialogVisible = false; // 关闭弹窗
      },
      // 删除操作
      handleDelete(row) {
        axios.delete(`http://www.wjyzlj.cn/pet/notice/${row.id}`)
        .then(response => {
            if(response.data.code == 200){
                this.$message({
                    message:'删除成功',
                    type:'success'
                })
                window.location.reload()
            }else{
                this.$message.error('删除失败')
            }
            console.log(response.data.code)
        })
        .catch(error => {
            this.$message.error('删除失败')
        })
      },
      // 分页切换
      handlePageChange(page) {
        this.currentPage = page;
        this.queryNotice()
      },
      // 查询所有通知
      queryNotice() {
        axios
          .get(`http://www.wjyzlj.cn/pet/notice/page?current=${this.currentPage}&pageSize=${this.pageSize}`)
          .then((response) => {
            this.noticeData = response.data.data.records; // 绑定数据
            this.totalElements = response.data.data.total
          })
          .catch((error) => {
            console.log(error);
          });
      },
      //查看公告
      goNoticePage(row){
        this.$router.push({
            path:'/noticePage',
            query:{
                title:row.title,
                date:row.createTime,
                content:row.content,
                author:row.author
            }
        })
      },
      //根据作者查找
      searchByTitle(){
        axios.get(`http://www.wjyzlj.cn/pet/notice/page?author=${this.searchWord}&current=${this.currentPage}&pageSize=${this.pageSize}`)
        .then(response => {
            this.noticeData = response.data.data.records
            this.totalElements = response.data.data.total
        })
        .catch(error => {
            console.log(error)
        })
        console.log(this.searchWord)
      },
      getCookie(name) {
    // 获取所有cookie字符串
    let cookies = document.cookie.split(';');
    // 遍历每个cookie
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();  // 去除空格
        if (cookie.startsWith(name + '=')) {
            return cookie.substring(name.length + 1);  // 返回cookie值
        }
    }
    
    return null;  // 如果没有找到指定的cookie，返回null
    }
    },
  };
  </script>
  
  <style scoped>
  .el-table {
    margin-top: 20px;
  }
  </style>